import React from "react";

/**
 * 设备黑名单拦截页
 * 当接口返回 403 且 code 为 FORBIDDEN_BFID 时展示，表示当前设备已被拉入黑名单
 */
export default function BlockedDevicePage() {
  return (
    <div
      className="blocked-device-page"
      style={{
        boxSizing: "border-box",
        background: "linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)",
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        color: "#e8e8e8",
      }}
    >
      <div
        style={{
          textAlign: "center",
          maxWidth: 320,
        }}
      >
        {/* 图标：盾牌+禁止 */}
        <div
          style={{
            width: 80,
            height: 80,
            margin: "0 auto 24px",
            borderRadius: "50%",
            background: "rgba(255, 82, 82, 0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <svg
            width="44"
            height="44"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ff5252"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <line x1="6" y1="12" x2="18" y2="12" />
          </svg>
        </div>

        <h1
          style={{
            margin: "0 0 12px",
            fontSize: "1.35rem",
            fontWeight: 700,
            color: "#fff",
          }}
        >
          Access Restricted
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.9rem",
            lineHeight: 1.5,
            color: "rgba(255,255,255,0.75)",
          }}
        >
          This device is not authorized to access the service. If you believe
          this is an error, please contact support.
        </p>
      </div>
    </div>
  );
}
